var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#F59D0E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8211 22.2751C24.7523 24.5251 22.7836 24.8063 22.7836 24.8063C21.0961 25.1438 18.9586 24.4126 17.2711 23.6251C14.8523 22.5001 12.7711 20.7001 11.3648 18.3938C10.7461 17.3251 10.1836 16.0876 10.1273 14.9063C10.1273 14.9063 9.9023 12.9376 11.8148 11.3626C11.9836 11.2501 12.1523 11.1938 12.3773 11.1938H13.2211C13.5586 11.1938 13.8961 11.4188 14.0086 11.7563L15.3023 14.9063C15.4148 15.2438 15.3586 15.5813 15.1336 15.8626L14.2898 16.7626C14.0086 17.0438 14.0086 17.4376 14.1773 17.7751C14.2336 17.8876 14.3461 18.0563 14.5148 18.2251C15.5273 19.5751 16.8773 20.5876 18.3961 21.2626C18.6211 21.3751 18.7898 21.4313 18.9586 21.4876C19.3523 21.6001 19.6898 21.4313 19.9148 21.1501L20.5898 20.1376C20.7586 19.8563 21.0961 19.6876 21.4336 19.7438L24.8086 20.2501C25.1461 20.3063 25.4273 20.5876 25.5398 20.9251L25.7648 21.7688C25.8773 21.8813 25.8773 22.1063 25.8211 22.2751Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/Call.bb0969cd9aaf2604648f94184b23f091.svg";
export { ForwardRef as ReactComponent };